import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import './styles.css';
import {fromBackendDate} from '../../../utils/DateUtils';

class ImagesViewer extends React.Component {
    constructor(props) {
        super(props);

        const sortedImages = [...props.images].sort(
            (a, b) => fromBackendDate(b.createdAt) - fromBackendDate(a.createdAt)
        );

        this.state = {
            photoIndex: props.photoIndex,
            imageLinks: sortedImages.map(img => img.url),
            rotation: 0,
        };
    }

    wrapIndex = (index) => {
        const {imageLinks} = this.state;
        return (index + imageLinks.length) % imageLinks.length;
    };

    rotateLeft = () => this.setState(prev => ({rotation: prev.rotation - 90}));
    rotateRight = () => this.setState(prev => ({rotation: prev.rotation + 90}));
    resetRotation = () => this.setState({rotation: 0});

    componentDidUpdate(prevProps, prevState) {
        const img = document.querySelector('.ril-image-current');
        if (img) {
            img.style.transform = `rotate(${this.state.rotation}deg)`;

            img.style.maxWidth = '98vw';
            img.style.maxHeight = '98vh';
            img.style.objectFit = 'contain';
            img.style.transformOrigin = 'center center';
        }

        if (prevState.photoIndex !== this.state.photoIndex) {
            this.setState({rotation: 0});
        }
    }

    render() {
        const {close} = this.props;
        const {photoIndex, imageLinks} = this.state;

        return (
            <Lightbox
                reactModalStyle={{overlay: {zIndex: 60000}}}

                mainSrc={imageLinks[photoIndex]}
                nextSrc={imageLinks[this.wrapIndex(photoIndex + 1)]}
                prevSrc={imageLinks[this.wrapIndex(photoIndex - 1)]}

                onCloseRequest={close}

                onMoveNextRequest={() =>
                    this.setState({photoIndex: this.wrapIndex(photoIndex - 1), rotation: 0})
                }

                onMovePrevRequest={() =>
                    this.setState({photoIndex: this.wrapIndex(photoIndex + 1), rotation: 0})
                }

                toolbarButtons={[
                    <button key="rotate-left" className="rotate-button" onClick={this.rotateLeft}>
                        ⟲
                    </button>,
                    <button key="rotate-right" className="rotate-button" onClick={this.rotateRight}>
                        ⟳
                    </button>,
                ]}
            />
        );
    }
}

ImagesViewer.propTypes = {
    images: PropTypes.array.isRequired,
    photoIndex: PropTypes.number.isRequired,
    close: PropTypes.func.isRequired,
};

export default ImagesViewer;



// WEBPACK FOOTER //
// ./src/components-new/general/ImagesViewer/index.jsx